import React from "react";
import { Chip, ChipProps } from "@mui/material";
import { LeaveApplicationStatus } from "../../../constants/leave";
import { TLeaveApplicationStatus } from "../../../interfaces/LeaveApplicationInterface";

interface LeaveApplicationStatusProps {
  status: TLeaveApplicationStatus;
  size?: ChipProps["size"];
}

// eslint-disable-next-line import/prefer-default-export
export const LeaveApplicationStatusChip: React.FC<LeaveApplicationStatusProps> = ({
  status,
  size = "small"
}): React.ReactNode => {
  const getStatusConfig = (statusValue: TLeaveApplicationStatus) => {
    switch (statusValue) {
      case LeaveApplicationStatus.PENDING:
        return {
          label: "Pending",
          color: "warning" as const,
          variant: "outlined" as const
        };
      case LeaveApplicationStatus.APPROVED:
        return {
          label: "Approved",
          color: "success" as const,
          variant: "filled" as const
        };
      case LeaveApplicationStatus.REJECTED:
        return {
          label: "Rejected",
          color: "error" as const,
          variant: "filled" as const
        };
      default:
        return {
          label: statusValue,
          color: "default" as const,
          variant: "outlined" as const
        };
    }
  };

  const config = getStatusConfig(status);

  return <Chip label={config.label} color={config.color} variant={config.variant} size={size} />;
};
